import React from 'react';
import { Meeting } from '../../../types/meeting';
import { useElapsed } from '../live/useElapsed';

interface MeetingStatusBadgeProps {
  meeting: Meeting;
  // Overrides the meeting's own live_state (e.g. live SSE state in the
  // workspace). When omitted, falls back to meeting.live_state.is_live.
  isLive?: boolean;
}

// Renders the meeting lifecycle status, promoting it to a "Live now" badge
// whenever the meeting's live session is running. "Live now" is a display state
// derived from live_state, not a persisted status value.
const MeetingStatusBadge: React.FC<MeetingStatusBadgeProps> = ({ meeting, isLive }) => {
  const live = isLive ?? meeting.live_state?.is_live === true;
  const elapsed = useElapsed(meeting.live_state?.started_at, live);

  if (live) {
    return (
      <span className="meeting-status-badge meeting-status-live">
        ● Live now
        {elapsed && (
          <span className="meeting-status-live-elapsed" aria-label={`Elapsed ${elapsed}`}>{elapsed}</span>
        )}
      </span>
    );
  }

  return (
    <span className={`meeting-status-badge meeting-status-${meeting.status}`}>{meeting.status}</span>
  );
};

export default MeetingStatusBadge;
